class CartFactory {
    static validation(){
        if(!localStorage.getItem('cartData')) return null;
        return JSON.parse(localStorage.getItem('cartData'));
    }
    static save(cart){
        localStorage.setItem('cartData', JSON.stringify(cart));
    }
    static reset(){
        let cart = {
            id: null, 
            items: [],
            state: null
        };
        return cart;
    }
    static initLastCart(lastCarrito){
        let items = lastCarrito.detalle.map( coupon => ({ id: coupon.id }));
        return {
            id: lastCarrito.id,
            items,
            state: lastCarrito.estado,
            maxItems: lastCarrito.maxItems,
            nroDocumento: lastCarrito.nroDocumento,
            tipoDocumento: lastCarrito.tipoDocumento,
            createAt: lastCarrito.updateAt
        };
    }
    static getId() {
        const cartData = localStorage.getItem('cartData');
        if (!cartData) return null;
        
        const parsedCartData = JSON.parse(cartData);
        return parsedCartData.id;
    }
}

export default CartFactory;